import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import api from '@api/Apis';
import _ from 'lodash';
import AccordionSec, { FrequentlyProducts, ReviewSection, SupplimentPopUp, AddCardButtonText } from '../common';
import { Rating, Button } from "@mui/material";
import VedioPlayer from '@Components/Common/VedioPlayer';
import { Star } from '@mui/icons-material';
import SvgAnimationBackground from '@Components/Common/SvgAnimationBackground';
import { SecondSection, UniqueDeliveryComp } from '../common';
import dynamic from 'next/dynamic';
import ReviewComponent from '@Components/Common/RatingSection/ReviewComponent';
import { ProductPageFooter } from '../productPage.style';
import { Parallax } from 'react-scroll-parallax';
import DialogComponent from '@Components/Common/DialogComponent';
import { DialogSectionCss } from '@PagesComponent/ActiveSmartShip/ActiveStyleComp';
import parse from 'html-react-parser';
import Slider from "react-slick";
import ProvenComponent from '@PagesComponent/Home/provenComponent';
import { forwardRef } from 'react';
import { isTruthyAutoshipFlag } from '@Components/Common/commonMethods';

const ProductPageDesign = dynamic(
  () => import('../productPage.style'),
  { ssr: false }
);

const AccordionProductSec = forwardRef(({ title, content, active, onToggle }, ref) => {
  const handleClick = () => {
    onToggle();
    const centerPosition = (document.documentElement.scrollHeight - window.innerHeight) / 5;

    window.scroll({
      top: centerPosition,
      behavior: 'smooth'
    });
  };


  return (
    <div className="accordion-item-div">
      <div className="accordion-title-div" onClick={handleClick}>
        <div className="accord-head">{title}</div>
        <div className="icon-accor">{active ? '-' : '+'}</div>
      </div>
      {active && <div className="accordion-content" ref={ref}>{content}</div>}
    </div>
  );
});


const AccordionInnerSec = forwardRef(({ product, }, ref) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleToggle = (index) => {

    setActiveIndex(activeIndex === index ? null : index);
  };

  const data = [
    { title: "WHAT IT DOES", content: product?.products?.description, for: "desktop_view", id: product?.products?.id },
    { title: "HOW TO USE", content: product?.products?.benefits, for: "desktop_view", id: product?.products?.id },
  ];

  return (
    <div className="accordin">
      {data?.map((value, index) => (
        <div key={index} className={`${value.for ? value.for : ""} accordion`}>
          {value?.content && (
            <AccordionProductSec
              title={value.title}
              content={parse(String(value.content))}
              active={activeIndex === value?.id + index}
              ref={ref}
              onToggle={() => handleToggle(value?.id + index)}
            />
          )}
        </div>
      ))}
    </div>
  );
})


export default function Product(props) {
  const { customerCheck, minCartAutoshipCheck, smartShipCheck, setInnerLoader } = props;
  const hasActiveAutoship = isTruthyAutoshipFlag(minCartAutoshipCheck) || isTruthyAutoshipFlag(smartShipCheck);
  const formatBonusValue = (value) => String(value ?? "").split(" ")[0];

  const router = useRouter()
  const { id, name, page } = router.query;
  const [productqty, setQty] = useState(1);
  const [product, setproduct] = useState();
  const [productvariantid, setproductvariantid] = useState();
  const [costtype, setcosttype] = useState([]);
  const [variantdetals, setvariantdetails] = useState();
  const [Logintoken, setToken] = useState()
  const [relatedData, setRelatedData] = useState();
  const [productDetailContent, setProductDetailContent] = useState(null);
  const [reviewData, setReviewData] = useState([]);
  const [reviewCount, setReviewCount] = useState(0);
  const [reviewCurrentPage, setReviewCurrentPage] = useState(1);
  const [reviewTotalPages, setReviewTotalPages] = useState(1);
  const [open, setOpen] = useState(false);
  const [openReview, setOpenReview] = useState(false);
  const [openKosher, setOpenKosher] = useState(false)
  const [cartNotify, setCartNotify] = useState('')
  const [playingVideo, setPlayingVideo] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [activeMedia, setActiveMedia] = useState({ index: 0, type: 'image' });

  // For add to cart product/variant
  const myRef = useRef(null);
  const seeRef = useRef(null);
  const addToCart = async (id, quantity) => {
    const formData = {
      product_id: id, variant_id: productvariantid,
      token: Logintoken, quantity: quantity, is_autoship: _.find(costtype, { id: id })?.value === 'AutoShip' ? true : false
    };
    await api.addToCart(formData).then(res => {
      if (res?.data?.code === 1) {
        setCartNotify("Added To Cart")
        setTimeout(() => {
          setCartNotify('');
        }, 3000)
        // toast.success(res.data.message, { duration: 5 })
        props?.setshowminicart(true)
      }
    })
  }
  // for add product to wishlist
  const addToWishList = (e) => {
    const formData = { product_id: id, variant_id: productvariantid, token: Logintoken, quantity: productqty };
    api.addToWishlist(formData).then(res => {
      if (res?.data?.code === 1) {
        props?.setupdatecartdata(true)
        // toast.success('product added in wishlist successfully')
      }
    })
  }


  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const fetchProductReviews = async (productId, page = 1) => {
    try {
      const res = await api.getProductReviews(productId, page);
      if (res?.status === 200 && res?.data?.data?.code === 1) {
        setReviewData(res?.data?.data?.reviews || []);
        setReviewCount(res?.data?.count || 0);
        setReviewTotalPages(res?.data?.total_pages || 1);
        setReviewCurrentPage(res?.data?.current_page || page);
      } else {
        setReviewData([]);
        setReviewCount(0);
        setReviewTotalPages(1);
        setReviewCurrentPage(1);
      }
    } catch (error) {
      console.error('Error fetching product reviews:', error);
    }
  };

  const ProductDataFunction = async (id) => {
    try {
      setInnerLoader(true)
      const res = await api.getProductByProductid(id);
      if (res?.data?.code === 1) {
        setInnerLoader(false);
        setProductDetailContent(res?.data?.product_detail_data);
        setvariantdetails(res?.data?.products?.variants);
        setproduct(res?.data);
        setQty(1);
        setRelatedData(res?.data?.frequently_bought_products);
      } else {
        console.error('API returned error code:', res?.data?.code);
      }
    } catch (error) {
      console.error('Error fetching product data:', error);
      router.back();
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('Token') || null;
    setToken(token);
    // setInnerLoader(true);
    setcosttype([{ id: id, value: "Normal" }]);
    if (id) {
      ProductDataFunction(id);
      fetchProductReviews(id);
    }
  }, [router, id]);


  useEffect(() => {
    api.getAllBannersApi('us').then(res => {
      props?.setbannerData(res?.data?.Promotions);

    })
  }, [])

  const ForRatingStar = (count = 0) => {
    const Rating = [];
    for (let i = 1; i <= count; i++) {
      Rating.push(<i className="fa fa-star" aria-hidden="true" key={i + 1}></i>);
    }
    return Rating;
  }


  const productId = product?.products?.id;

  // const productPromotions = props?.bannerData
  //   ?.filter(promo => promo.promotion_type === "Product_Promotions")
  //   ?.flatMap(promo => promo?.banners)
  //   ?.filter(banner => banner?.is_active);

  const productPromotions = Array.isArray(props?.bannerData)
  ? props.bannerData
      .filter(promo => promo?.promotion_type === "Product_Promotions")
      .reduce((acc, promo) => {
        if (Array.isArray(promo?.banners)) {
          acc = acc.concat(promo.banners);
        }
        return acc;
      }, [])
      .filter(banner => banner?.is_active)
  : [];


  const matchingProductPromotions = productPromotions?.filter(banner => banner?.product == productId);
  const promotionSlides = (matchingProductPromotions || [])?.map(promo => ({
    urlData: `${process.env.API_URL}${promo?.banner_image}`,
    urlData2: `${process.env.API_URL}${promo?.banner_image}`,
    thumbnail: `${process.env.API_URL}${promo?.banner_image}`,
    thumbnail2: `${process.env.API_URL}${promo?.banner_image}`,
    isImage: true,
    promoImage: true,
  }));


  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const slidersBanner = useRef();
  const settings1 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    pauseOnHover: false,
  };
  const [showImage, setShowImage] = useState(true);

  const BiotickKaireVideos = [
    {
      urlData: `${process.env.API_URL}${product?.products?.main_image}`,
      thumbnail: `${process.env.API_URL}${product?.products?.main_image}`,
      isImage: true,
    },
    ...promotionSlides,

    {
      urlData: `https://player.vimeo.com/video/1005957632?autoplay=false&loop=0&autopause=1&controls=true`,
      thumbnail: '/images/biotic-man.jpg',
    },
    {
      urlData: "https://player.vimeo.com/video/1010759116?autoplay=false&loop=0&autopause=1&controls=true",
      thumbnail: '/images/girl-maritime.jpg',
    },
    {
      urlData: "https://player.vimeo.com/video/1005901656?autoplay=false&loop=0&autopause=1&controls=true",
      thumbnail: "/images/man-prime.jpg",
    },
  ]
  const BiotickSilverKaireVideos = [
    {
      urlData: `${process.env.API_URL}${product?.products?.main_image}`,
      thumbnail: `${process.env.API_URL}${product?.products?.main_image}`,
      urlData2: `${process.env.API_URL}${product?.products?.main_image}`,
      thumbnail2: `${process.env.API_URL}${product?.products?.main_image}`,
      isImage: true,
    },
    ...promotionSlides,
    {
      urlData2: "https://player.vimeo.com/video/1053933481?autoplay=false&loop=0&autopause=1&controls=true",
      thumbnail2: "/images/man-prime-pic.jpg",
      urlData: "https://player.vimeo.com/video/1055079623?autoplay=false&loop=0&autopause=1&controls=true",
      thumbnail: "/images/silver-girl.jpg",
    },

  ]


  const Prime180kaireVideos = [
    {
      urlData: `${process.env.API_URL}${product?.products?.main_image}`,
      thumbnail: `${process.env.API_URL}${product?.products?.main_image}`,
      isImage: true,
    },
    ...promotionSlides,

    {
      urlData: "https://player.vimeo.com/video/1053933481?autoplay=false&loop=0&autopause=1&controls=true",
      thumbnail: '/images/man-prime-pic.jpg',
    },

  ]


  const handleThumbnailClick = (index) => {
    const selected = BiotickKaireVideos[index];
    if (selected.isImage) {
      setActiveMedia({ index, type: 'image' });
      setPlayingVideo(null);
    } else {
      setActiveMedia({ index, type: 'video' });
      setPlayingVideo(index);
    }
  };


  const handleThumbnailSilverKaireClick = (index) => {
    const selected = BiotickSilverKaireVideos[index];
    if (selected.isImage) {
      setActiveMedia({ index, type: 'image' });
      setPlayingVideo(null);
    } else {
      setActiveMedia({ index, type: 'video' });
      setPlayingVideo(index);
    }
  };

  const handlePrime180KaireClick = (index) => {
    const selected = Prime180kaireVideos[index];
    if (selected.isImage) {
      setActiveMedia({ index, type: 'image' });
      setPlayingVideo(null);
    } else {
      setActiveMedia({ index, type: 'video' });
      setPlayingVideo(index);
    }
  };

  // const productPromoBanners = props?.bannerData?.filter(promotion => promotion?.promotion_type === "Product_Promotions")?.flatMap(promotion => {
  //   if (Array.isArray(promotion?.banners)) {
  //     return promotion?.banners.filter(banner => banner?.is_active);
  //   }
  //   return [];
  // }) ?? [];

  const productPromoBanners = Array.isArray(props?.bannerData)
  ? props.bannerData
      .filter(promotion => promotion?.promotion_type === "Product_Promotions")
      .reduce((acc, promotion) => {
        if (Array.isArray(promotion?.banners)) {
          const activeBanners = promotion.banners.filter(banner => banner?.is_active);
          acc = acc.concat(activeBanners);
        }
        return acc;
      }, [])
  : [];


  return (
    <>
      <Head><title>{name?.replace(/_/g, ' ')}</title></Head>
      <div className={productDetailContent === null ? "single-page-spacing" : ""}>
        {productDetailContent &&
          <ProductPageDesign bannerImage={productDetailContent?.banner_dummy_image} section2Image={productDetailContent?.section2_dummyImage}>
            {(product?.products?.promotion_image_desktop?.length > 0) &&
              <div className='discount_image'>
                <img src={`${process.env.API_URL}/${product?.products?.promotion_image_desktop}`} />
                <img src={`${process.env.API_URL}/${product?.products?.promotion_image_mobile}`} className="for_mob" />
              </div>
            }
            {productPromoBanners?.map((banner, index) => (
              <div key={banner.id}>
                {(productDetailContent?.product === banner?.product && banner?.banner_location === "hero_image") &&
                  <div className="text-content-promotion">
                    {banner?.text_content && (
                      <div className='banner-promotion'>
                        <p
                          style={{ color: banner?.text_color, backgroundColor: banner?.background_color }}
                          dangerouslySetInnerHTML={{ __html: banner?.text_content }}
                        />
                      </div>
                    )}
                    {banner.banner_image &&
                      <img
                        src={process.env.API_URL + banner.banner_image}
                        alt={banner.text_heading}
                        style={{ backgroundColor: banner.background_color }}
                      />
                    }
                  </div>
                }

                {(productDetailContent?.product === banner?.product && banner?.banner_location === "onheader") &&
                  <div className="text-content-promotion">
                    {banner?.text_content && (
                      <div className='banner-promotion'>
                        <p
                          style={{ color: banner?.text_color, backgroundColor: banner?.background_color }}
                          dangerouslySetInnerHTML={{ __html: banner?.text_content }}
                        />
                      </div>
                    )}
                  </div>
                }
              </div>


            ))}

            <div className={`${product?.products?.promotion_image_desktop?.length > 0 ? "product-section-slider discount_image_active" : "product-section-slider"}`}>
              <div className="product-section-details">
                <div className='container'>
                  <div className="row product_detail_container">
                    <div className="col-md-5">
                      <div className="product-image">
                        {productDetailContent?.id === 19 &&
                          <>
                            {activeMedia.type === 'video' ? (
                              <div className="video-player">
                                <iframe
                                  src={BiotickKaireVideos[activeMedia.index]?.urlData.replace('autoplay=false', 'autoplay=true')}
                                  width="1000"
                                  height="800"
                                  frameBorder="0"
                                  allow="autoplay; fullscreen;"
                                  allowFullScreen loading="lazy"
                                ></iframe>
                              </div>
                            ) : (
                              <div className="product-img-block">
                                <img
                                  src={BiotickKaireVideos[activeMedia.index]?.urlData}
                                  className="product_img"
                                  loading="lazy"
                                  alt="Selected Product"
                                />
                              </div>
                            )}

                          </>
                        }

                        {productDetailContent?.id === 19 &&
                          <div className='all-images-section'>
                            <div className="thumbnails">
                              {BiotickKaireVideos?.map((video, index) => (
                                <div
                                  key={index}
                                  className={`biotickakire-video ${activeMedia.index === index ? "active" : ""}`}
                                  onClick={() => handleThumbnailClick(index)}
                                >
                                  <img
                                    src={video.thumbnail}
                                    alt={`Thumbnail video ${index + 1}`}
                                    style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
                                  />
                                </div>
                              ))}
                            </div>

                          </div>
                        }
                        {(productDetailContent?.id === 7 || productDetailContent?.id === 8) &&
                          <>
                            {activeMedia?.type === 'video' ? (
                              <div className="video-player">
                                <iframe
                                  src={productDetailContent?.id === 7 ? BiotickSilverKaireVideos[activeMedia.index]?.urlData : BiotickSilverKaireVideos[activeMedia.index]?.urlData2?.replace('autoplay=false', 'autoplay=true')}
                                  width="1000"
                                  height="800"
                                  frameBorder="0"
                                  allow="autoplay; fullscreen;"
                                  allowFullScreen loading="lazy"
                                ></iframe>
                              </div>
                            ) : (
                              <div className="product-img-block">
                                <img
                                  src={BiotickSilverKaireVideos[activeMedia?.index]?.urlData}
                                  className="product_img"
                                  loading="lazy"
                                  alt="Selected Product"
                                />
                              </div>
                            )}

                          </>
                        }

                        {(productDetailContent?.id === 7 || productDetailContent?.id === 8) &&
                          <div className='all-images-section'>
                            <div className="thumbnails">
                              {BiotickSilverKaireVideos?.map((video, index) => (
                                <div key={index} className={`biotickakire-video ${activeMedia.index === index ? "active" : ""}`}
                                  onClick={() => handleThumbnailSilverKaireClick(index)}
                                >
                                  <img
                                    src={
                                      productDetailContent?.id === 7 ? video.thumbnail : video.thumbnail2
                                    }
                                    alt={`Thumbnail video ${index + 1}`}
                                    style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
                                  />
                                </div>
                              ))}
                            </div>

                          </div>
                        }

                        {(productDetailContent?.id === 4) &&
                          <>
                            {activeMedia.type === 'video' ? (
                              <div className="video-player">
                                <iframe
                                  src={Prime180kaireVideos[activeMedia.index]?.urlData.replace('autoplay=false', 'autoplay=true')}
                                  width="1000"
                                  height="800"
                                  frameBorder="0"
                                  allow="autoplay; fullscreen;"
                                  allowFullScreen loading="lazy"
                                ></iframe>
                              </div>
                            ) : (
                              <div className="product-img-block">
                                <img
                                  src={Prime180kaireVideos[activeMedia.index]?.urlData}
                                  className="product_img"
                                  loading="lazy"
                                  alt="Selected Product"
                                />
                              </div>
                            )}

                          </>
                        }

                        {(productDetailContent?.id === 4) &&
                          <div className='all-images-section'>
                            <div className="thumbnails">
                              {Prime180kaireVideos?.map((video, index) => (
                                <div key={index} className={`biotickakire-video ${activeMedia.index === index ? "active" : ""}`}
                                  onClick={() => handlePrime180KaireClick(index)}
                                >
                                  <img
                                    src={video.thumbnail}
                                    alt={`Thumbnail video ${index + 1}`}
                                    style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
                                  />
                                </div>
                              ))}
                            </div>

                          </div>
                        }
                      </div>
                    </div>
                    <div className="col-md-7">
                      <div className="custom-cont">
                        <div className="first_section">
                          <h2 className="title">{product?.products?.name &&
                            `${product?.product_name || ""} ${product?.products?.name || ""}`}
                            {product?.products?.name !== "BioticKaire+" && product?.products?.name !== "SilverKaire" &&
                              <sup style={{ fontSize: '26px' }}>™</sup>}
                          </h2>
                          <span>{productDetailContent?.asked_section && parse(productDetailContent?.asked_section)}</span>
                        </div>
                        <SecondSection data={{
                          smartShipCheck,
                          costtype,
                          setcosttype,
                          id: id,
                          minCartAutoshipCheck,
                          productCost: product?.products.cost_price,
                          productSmartShip: product?.products.autoship_cost_price,
                          hasPromotion: product?.products?.has_promotion,
                          originalPrice: product?.products?.original_price,
                          promotionalPrice: product?.products?.promotional_price,
                          promotionalAutoshipPrice: product?.products?.promotional_autoship_price,
                        }} />
                        <div className="third_section">
                          <div className="quantity_section box">
                            <span><b>Qty:</b></span>
                            <div id="qty">
                              <button type="button" id="sub" className="sub" onClick={(e) => {
                                setQty(productqty > 1 ? productqty - 1 : productqty)
                              }}>-</button>
                              <input type="text" value={productqty} name="qty" onChange={(e) => {
                                setQty(e.target.value)
                              }} min="1" max={product?.products?.quantity} readOnly />
                              <button type="button" id="add" className="add" onClick={(e) => {
                                setQty(productqty + 1);
                              }}>+</button>
                            </div>
                          </div>
                          {productPromoBanners?.map((banner, index) => (
                            <div key={banner.id}>
                              {productDetailContent?.product === banner?.product && banner?.banner_location === "above_cart" &&
                                <div className="text-content-promotion">
                                  <p
                                    style={{ color: banner?.text_color, backgroundColor: banner?.background_color }}
                                    dangerouslySetInnerHTML={{ __html: banner?.text_content }}
                                  />
                                </div>
                              }
                            </div>
                          ))}
                          <div className="add_button_div">
                            <div className={`btn-sec Add_to_cart ${product?.products?.is_stock_available ? '' : 'out-of-stock'}`} >
                              <button disabled={!product?.products?.is_stock_available}
                                type="button" id={product?.products?.id}
                                onClick={(e) => addToCart(id, productqty)}>
                                {AddCardButtonText(product?.products?.is_stock_available, costtype, id)}
                              </button>
                            </div>
                          </div>
                          {productPromoBanners?.map((banner, index) => (
                            <div key={banner.id}>
                              {productDetailContent?.product === banner?.product && banner?.banner_location === "Below_Cart" &&
                                <div className="text-content-promotion">
                                  <p
                                    style={{ color: banner?.text_color, backgroundColor: banner?.background_color }}
                                    dangerouslySetInnerHTML={{ __html: banner?.text_content }}
                                  />
                                </div>
                              }
                            </div>
                          ))}
                        </div>
                        <div className="fourth_section">
                          <div className="review-section-now">
                            {props.isLogin || Logintoken !== null &&
                              <p>BV: {(_.find(costtype, { id: id })?.value === 'AutoShip' || hasActiveAutoship) ? formatBonusValue(product?.products?.autoship_bonus_value) : formatBonusValue(product?.products?.bonus_value)} </p>
                            }
                            <ul>
                              <li>
                                <Rating
                                  name="rating"
                                  value={4}
                                  readOnly
                                  sx={{ color: "black" }}
                                  emptyIcon={<Star style={{ opacity: 0.55 }} fontSize="inherit" />}
                                />
                              </li>
                              <li className="review_list" onClick={() => myRef.current.scrollIntoView()}>
                                <a href="#" style={{ pointerEvents: "none" }}>{reviewCount} reviews</a>
                              </li>
                              {props.isLogin || Logintoken !== null &&
                                <>
                                  <li><span className="breaker">|</span><button onClick={() => setOpenReview(true)} style={{ background: "none", padding: 0 }}>Write a review</button></li>
                                  <ReviewComponent productId={id} productName={name?.replaceAll('_', " ")} section="product_page" open={openReview} handleClose={setOpenReview} setOpen={setOpen} reviewData={reviewData} setReviewData={setReviewData} onReviewSubmitted={() => fetchProductReviews(id, reviewCurrentPage)} />
                                </>
                              }
                            </ul>
                          </div>
                          {productDetailContent?.supplement_facts &&
                            <>
                              <div className="supplement-fact">
                                <Button className="subpplement_button" onClick={() => handleClickOpen()}>Supplement Facts</Button>
                                {/*{props.isLogin === true &&
                            <Button id={product?.products?.id} onClick={(e) => addToWishList(e)}>Add to WishList</Button>
                          }*/}
                                <SupplimentPopUp handleClose={handleClose} open={open} image={productDetailContent?.supplement_facts} />
                              </div>
                              {productDetailContent?.id !== 19 && productDetailContent?.id !== 7 &&
                                <div className="Kosher">
                                  <a style={{ cursor: 'pointer' }} onClick={() => setOpenKosher(true)} className="par-logo">  <img src="KosherLogo-ai.png" /><p><span>?</span>
                                    what is Kosher</p>
                                  </a>
                                </div>
                              }
                              <DialogComponent opend={openKosher} handleClose={() => setOpenKosher(false)} title="Description" classFor="order_details">
                                <DialogSectionCss>
                                  <div className="head_kosher">
                                    <h3>What is Kosher & What Does It Mean?</h3>
                                  </div>

                                  <p> According to the kldbkosher.org website, “Kosher is a Hebrew word that means fit, proper, or correct.
                                    Nowadays, it is mostly used to describe food and drink that complies with Jewish religious dietary law.”</p>

                                  <div className="certified">
                                    <h3> What is Kosher Certified?</h3>
                                  </div>
                                  <p> For a product to be kosher certified, and to qualify for a kosher certificate, each ingredient, food additive,
                                    and processing aid used in its production must also be kosher. Additionally, to be kosher certified,
                                    the production process must be suitable for kosher requirements and therefore it must be approved by a kosher auditor.
                                    Products may be rendered non-kosher if their production lines and equipment are also used to manufacture non-kosher products.</p>

                                </DialogSectionCss>
                              </DialogComponent>
                            </>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item-product-sec" id="content-more" >
                <div className="accordion-title-inner container" >
                  <AccordionInnerSec product={product} ref={seeRef} />
                </div>
              </div>

              {/* <div className="frequently_product_section">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      {relatedData?.length > 0 &&
                        <FrequentlyProducts
                          data={{
                            smartShipCheck,
                            minCartAutoshipCheck,
                            addToCart,
                            relatedData,
                            costtype, setcosttype,
                          }}
                          cartNotify={cartNotify} />
                      }
                    </div>
                  </div>
                </div>
              </div> */}
              {productDetailContent?.id === 8 &&
                <div className="product-discript-sec-main Maritime_120_section">
                  <div className='container'>
                    <div className='main-banner-section'>
                      <div className='left-side-image'>
                        <h2 className='heading-font home-heading-common'>Why Super Maritime Prime 120™ Pycnogenol<sup>®</sup>?</h2>
                        <div className='left-wrapper'>
                          <div className="product-image">
                            <div className="video-player">
                              <iframe
                                src="https://player.vimeo.com/video/1053933481?autoplay=false&loop=0&autopause=1&controls=true"
                                width="1000"
                                height="800"
                                frameBorder="0"
                                allow="autoplay; fullscreen;"
                                allowFullScreen loading="lazy"
                              ></iframe>
                            </div>
                          </div>
                          <div className='list-item-content'>
                            <ul>
                              <li>Certified Kosher, Vegan and Gluten Free</li>
                              <li>
                                4X More Effective Than ’Store-Bought’ Brands
                              </li>
                              <li>One of the Richest Antioxidants
                                Available</li>
                              <li>60 mg Per Tablet </li>
                              <li>Powerful Anti-Inflammatory</li>
                              <li>
                                Proprietary plant-based enzyme delivery
                                system designed for optimal efficacy
                                and bioavailability
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className='right-side-text'>
                        <div className='inside-right-sec'>

                          <div className='inner-img-div'>
                            <img src='/images/120layerimg.jpg' />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              }

              {productDetailContent?.id === 19 &&
                <div className="product-discript-sec-main biotic_kaire_section">
                  <div className='container'>
                    <div className='main-banner-section'>
                      <div className='left-side-image'>
                        <h2 className='heading-font home-heading-common'>Why BioticKaire+ with Pre-Pro-Post Biotics & Digestive Enzymes?</h2>
                        <div className='left-wrapper'>
                          <div className="product-image">
                            <div className="video-player">
                              <iframe
                                src="https://player.vimeo.com/video/1010759116?autoplay=false&loop=0&autopause=1&controls=true"
                                width="1000"
                                height="800"
                                frameBorder="0"
                                allow="autoplay; fullscreen;"
                                allowFullScreen loading="lazy"
                              ></iframe>
                            </div>
                          </div>
                          <div className='list-item-content'>

                            <ul>

                              <li>Comprehensive 4-in- Formula</li>
                              <li>Advanced Probiotic Strains</li>
                              <li>Innovative Prebiotic Support</li>
                              <li>Postbiotic Inclusion</li>
                              <li>Broad Spectrum Digestive Enzymes</li>
                              <li>Scientifically Backed Ingredients</li>
                              <li>Health Benefits Beyond Digestion</li>

                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className='right-side-text'>
                        <div className='inside-right-sec'>

                          <div className='inner-img-div'>
                            <img src='/images/BioticKairelayerImg.jpg' />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }


              {productDetailContent?.id === 7 &&

                <div className="product-discript-sec-main Silver_kaire_section">
                  <div className='container'>
                    <div className='main-banner-section'>
                      <div className='left-side-image'>
                        <h2 className='heading-font home-heading-common'>Why SilverKaire Silver?</h2>
                        <div className='left-wrapper'>
                          <div className="product-image">
                            <div className="video-player">
                              <iframe
                                src="https://player.vimeo.com/video/1055079623?autoplay=false&loop=0&autopause=1&controls=true"
                                width="1000"
                                height="800"
                                frameBorder="0"
                                allow="autoplay; fullscreen;"
                                allowFullScreen loading="lazy"
                              ></iframe>
                            </div>
                          </div>

                          <div className='list-item-content'>
                            <ul>
                              <li>Antibacterial Efficacy</li >
                              <li>Enhanced Absorption</li>
                              <li>Probiotic Compatibility</li>
                              <li>Comprehensive Health Support</li>
                              <li>Safety Profile</li>
                              <li>Rapid Elimination</li>
                              <li>Scientific Validation</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className='right-side-text'>
                        <div className='inside-right-sec'>

                          <div className='inner-img-div'>
                            <img src='/images/silverkarirelayer.png' />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              }

              {productDetailContent?.id === 4 &&
                <div className="product-discript-sec-main Prime_180_section">
                  <div className='container'>
                    <div className='main-banner-section'>
                      <div className='left-side-image'>
                        <h2 className='heading-font home-heading-common'>Why Maritime Prime 180™ Pycnogenol<sup>®</sup>?</h2>
                        <div className='left-wrapper'>
                          <div className="product-image">
                            <div className="video-player">
                              <iframe
                                src="https://player.vimeo.com/video/1053933481?autoplay=false&loop=0&autopause=1&controls=true"
                                frameBorder="0"
                                allow="autoplay; fullscreen;"
                                allowFullScreen loading="lazy"
                              ></iframe>
                            </div>
                          </div>
                          <div className='list-item-content'>
                            <ul>
                              <li>Certified Kosher, Vegan and Gluten Free</li>
                              <li> 4X More Effective Than ’Store-Bought’ Brands</li>
                              <li>One of the Richest Antioxidants Available</li>
                              <li>Smaller for Effortless Swallowing</li>
                              <li>20 mg per tablet</li>
                              <li>Powerful Anti-Inflammatory</li>
                              <li> Proprietary plant-based enzyme delivery
                                system designed for optimal efficacy
                                and bioavailability</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className='right-side-text'>
                        <div className='inside-right-sec'>

                          <div className='inner-img-div'>
                            <img src='/images/180layerimg.jpg' />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <div className='proven-benefits section'>
                <div className='container'>
                  <ProvenComponent productDetailContent={productDetailContent} costtype={costtype} />
                </div>
              </div>
            </div>
            <div className="customer-review-now" ref={myRef}>
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="review-customer">
                      <h5>What are people saying about this product?</h5>
                      <h2>Customer Reviews</h2>
                    </div>
                  </div>
                </div>
                <div id="review">
                  <ReviewSection
                    ForRatingStar={ForRatingStar}
                    reviewData={reviewData}
                    reviewCurrentPage={reviewCurrentPage}
                    reviewTotalPages={reviewTotalPages}
                    onPageChange={(page) => fetchProductReviews(id, page)}
                  />
                </div>
              </div>

            </div>
            {/*<SvgAnimationBackground />*/}
            <ProductPageFooter>
              <div className={`${scrolled ? 'price_section_footer scrolled' : 'price_section_footer'}`}>
                <div className='price-sec'>
                  <div className="price-inner-sec">
                    <SecondSection data={{
                      smartShipCheck,
                      costtype,
                      setcosttype,
                      id: id,
                      minCartAutoshipCheck,
                      productCost: product?.products.cost_price,
                      productSmartShip: product?.products.autoship_cost_price,
                      hasPromotion: product?.products?.has_promotion,
                      originalPrice: product?.products?.original_price,
                      promotionalPrice: product?.products?.promotional_price,
                      promotionalAutoshipPrice: product?.products?.promotional_autoship_price,
                    }} />
                    {/* {(customerCheck > 1) && */}
                    {props.isLogin &&
                      <h5 className="bonus_value">BV: {(_.find(costtype, { id: id })?.value === 'AutoShip' || hasActiveAutoship) ? formatBonusValue(product?.products?.autoship_bonus_value) : formatBonusValue(product?.products?.bonus_value)} </h5>
                    }
                    {/* } */}
                  </div>
                  <div className="footer-merge">
                    <div className="quality">
                      <div className="main-qty-sec">
                        <div className="box">
                          <div id="qty">
                            <button type="button" id="sub" className="sub" onClick={(e) => {
                              setQty(productqty > 1 ? productqty - 1 : productqty)
                            }}>-</button>
                            <input type="text" value={productqty} name="qty" onChange={(e) => {
                              setQty(e.target.value)
                            }} min="1" max={product?.products?.quantity} readOnly />
                            <button type="button" id="add" className="add" onClick={(e) => {
                              setQty(productqty + 1);
                            }}>+</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="cart-add">
                      {/* {operation === 'showpopup' && <Popups message={addtocartmessage} />} */}
                      <div className="add_button_div">
                        <div className={`btn-sec Add_to_cart ${product?.products?.is_stock_available ? '' : 'out-of-stock'}`} >
                          <button className="add_margin" disabled={!product?.products?.is_stock_available}
                            type="button" id={product?.products?.id}
                            onClick={(e) => addToCart(id, productqty)}>
                            {AddCardButtonText(product?.products?.is_stock_available, costtype, id)}
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </ProductPageFooter>
          </ProductPageDesign>
        }
      </div>
    </>
  )
}

export const getStaticPaths = async ({ id }) => {
  let paths;
  const defaultValues = {
    paths: [],
    fallback: true,
  };

  try {
    // const allSlugs = ["us/product/Test2%20Product/12/", "us/product/Test3%20Product/13/"];
    const res = await fetch(`${process.env.getAllProduct}?slug=us`)
    let data_page = await res?.json();
    data_page = data_page?.products
    paths = data_page?.map((c) => {
      let names = c?.name.replace('25%', '')
      let catname = names.replace('\t', '')
      catname = catname.replace(/\s/g, '_');
      return (`/us/product/${catname}/${c?.id}`)
    });    // paths = allSlugs.map((slug) => "/" + slug);

  } catch (e) { return defaultValues; }
  return {
    paths,
    fallback: true,
  };
};

export const getStaticProps = async ({ params: { page, id } }) => {
  let data_page = { products: [] };
  try {
    const res = await fetch(`${process.env.getAllProduct}?slug=us`);
    data_page = await res.json();
  } catch (e) {
    data_page = { products: [] };
  }
  return {
    props: {
      id, data_page
    },
    revalidate: 60,
  };
};
